import { render, staticRenderFns } from "./department-management.vue?vue&type=template&id=b2d443dc&scoped=true&"
import script from "./department-management.vue?vue&type=script&lang=js&"
export * from "./department-management.vue?vue&type=script&lang=js&"
import style0 from "./department-management.vue?vue&type=style&index=0&id=b2d443dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d443dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d443dc')) {
      api.createRecord('b2d443dc', component.options)
    } else {
      api.reload('b2d443dc', component.options)
    }
    module.hot.accept("./department-management.vue?vue&type=template&id=b2d443dc&scoped=true&", function () {
      api.rerender('b2d443dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-system-management/department-management.vue"
export default component.exports